module.exports = __webpack_public_path__ + "static/media/no-answer.21e49459.svg";